import React, { useState } from 'react'
import { Button, Col, Row } from 'reactstrap';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';

//Context
import { useAuth } from '../../context/auth';

//Helpers
import { objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';
import mascaras from '../../helpers/mascaras';
import { showMessage } from '../../helpers/message';

//API
import FichaConsultaDePlaca from './components/FichaConsultaDePlaca';
import { useLocation } from 'react-router-dom';
import fiscalizacaoVeiculo_api from '../../api/fiscalizacaoVeiculo_api';


function initialConsultaDePlaca() {
    return {
        placaVeiculo: "",
    }
}

export default function ConsultaDePlaca() {
    const { setLoading } = useAuth();

    //Location para pegar o state de filtros caso tenha
    const location = useLocation();

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(location.state && location.state.filtros ? location.state.filtros : initialConsultaDePlaca);

    //Estado de controle de visualização da ficha
    const [ficha, setFicha] = useState(null);

    //Estado de controle dos errors
    const [errors, setErrors] = useState({});

    //campos obrigatorios dos filtros
    const campos = [
        objCampo({ name: "placaVeiculo", required: true })
    ];

    //OnChange do campo
    const onChangeCampos = (e) => {
        const { name, value } = e.target;

        const _filtros = {
            ...filtros,
            [name]: value
        };

        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_filtros, campo);

        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setFiltros(_filtros);
    }

    async function handleConsultaPlaca() {
        const _errors = validarCampos(filtros, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        try {
            setLoading(true);
            const { data } = await fiscalizacaoVeiculo_api.GetPlaca(filtros.placaVeiculo);
            setFicha(data);
        } catch (error) {
            showMessage("Error", error?.message ?? "Erro na operação", "error", null);
        } finally {
            setLoading(false);
        }
    }

    if (ficha) return <FichaConsultaDePlaca
        filtros={filtros}
        dadosVeiculo={ficha}
        handleReturn={() => setFicha(null)}
    />

    return (
        <MainCard noCard>
            <Row className='d-flex align-items-center'>
                <Col md="6" lg="3">
                    <TextField
                        name="placaVeiculo"
                        label={"Placa"}
                        mask={mascaras.placaMask}
                        value={filtros.placaVeiculo}
                        onChange={onChangeCampos}
                        maxLength="9"
                        invalid={errors.placaVeiculo}
                    />
                </Col>
                <Col md="6" lg="4" className='mb-3'>
                    <Button
                        onClick={handleConsultaPlaca}
                        color='primary'
                        className='mt-0 mt-4'
                    >
                        <FontAwesomeIcon icon={faSearch} /> Buscar
                    </Button>
                </Col>
            </Row>
        </MainCard>
    )
}
